import React from 'react';
import { motion } from 'framer-motion';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6 } }
};

const Terms: React.FC = () => {
  return (
    <div className="pt-28 pb-16">
      <div className="container mx-auto px-4">
        <motion.h1 
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary"
        >
          Terms of Service
        </motion.h1>

        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing or using the Skill Point Consultants website, you agree to be bound by these Terms of Service. 
              If you do not agree to all the terms and conditions, you may not access or use our services.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">2. Description of Services</h2>
            <p className="text-gray-700 mb-4">
              Skill Point Consultants provides career consulting, professional training, and recruitment services. 
              We connect job seekers with employers and offer skill development resources to help professionals advance their careers.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">3. User Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              When using our website and services, you agree to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your account information</li>
              <li>Use our services for lawful purposes only</li>
              <li>Not interfere with the functionality of our website</li>
              <li>Not attempt to gain unauthorized access to our systems</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">4. Intellectual Property</h2>
            <p className="text-gray-700 mb-4">
              All content on the Skill Point Consultants website, including text, graphics, logos, images, and software, 
              is the property of Skill Point Consultants or its content suppliers and is protected by copyright and other intellectual property laws.
            </p>
            <p className="text-gray-700">
              You may not reproduce, distribute, modify, or create derivative works from any content without our express written permission.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">5. Limitation of Liability</h2>
            <p className="text-gray-700">
              Skill Point Consultants and its officers, employees, and agents shall not be liable for any indirect, incidental, 
              special, consequential, or punitive damages, including loss of profits, data, or other intangible losses, resulting from your access to or use of our services.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">6. Modification of Terms</h2>
            <p className="text-gray-700">
              We reserve the right to modify these Terms of Service at any time. Your continued use of our services after 
              any such changes indicates your acceptance of the modified terms.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-secondary">7. Governing Law</h2>
            <p className="text-gray-700">
              These Terms of Service shall be governed by and construed in accordance with the laws of India, 
              without regard to its conflict of law provisions.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4 text-secondary">8. Contact Information</h2>
            <p className="text-gray-700">
              If you have any questions about these Terms of Service, please contact us at:{' '}
              <a href="mailto:business@skillpointconsultants.com" className="text-primary hover:underline">
                business@skillpointconsultants.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 